module.exports = __webpack_public_path__ + "img/y8.927afa23.webp";